/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { BiHomeAlt } from 'react-icons/bi';
import { MdKeyboardArrowRight, MdSearch } from 'react-icons/md';
import Loader from '../../../../Components/loader/loader';
import Header from '../../../../Components/Dashboard/Header/Header';
import Sidebar from '../../../../Components/Dashboard/Sidebar/Sidebar';
import { Apiurl, GetToken } from '../../../../Utils/utils';
import axios from 'axios';
import "./TasksInProgress.css"
import { toast } from 'react-toastify';

const TasksInProgress = () => {
    const LoginToken = GetToken();
    const [loading, setLoading] = useState(false);
    const [showSidebar, setShowSidebar] = useState(true);
    const [TasksInProgressAllData,setViewAlluserTask]=useState([])
 
    const addAMPM = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`);
        if (isNaN(time.getTime())) {
          return "";
        }
        const options = { hour: "numeric", minute: "numeric", hour12: true };
        return time.toLocaleTimeString("en-US", options);
      };

    

    const GetInProgressTasks = () => {
        setLoading(true);
        const options = {
          method: "GET",
          headers: {
            "access-control-allow-origin": "*", 
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },
          url:`${Apiurl()}/Task/GetInProgressTasks`,
        };
    
        axios(options)
          .then((response) => {
            setLoading(false);
            if (response.status === 200) {
              const data = JSON.parse(response?.data?.data);
          
              setViewAlluserTask(data)
                
            }
          })
          .catch((error) => {
            setLoading(false);
            // console.error("Error fetching client data:", error);
          });
      };        
      useEffect(()=>{
        GetInProgressTasks()
      },[])
      const TaskFailed = (item) => {
        setLoading(true);
       const data={}
       data.Id = item.TaskId
        const option = {
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },  
          url:`${Apiurl()}/Task/TaskReviwedasFailed`,
          data: { data: JSON.stringify(data) },

        };
        axios(option)
          .then((e) => {
            setLoading(false);
            if (e?.status === 200) {
              toast.success(e?.data?.message);
            }
          })
          .catch((error) => {
            setLoading(false);
          });
      };
      const TaskSuccess = (item) => {
        setLoading(true);
       const data={}
       data.Id = item.TaskId
        const option = {
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },  
          url:`${Apiurl()}/Task/TaskReviwedasSuccess`,
          data: { data: JSON.stringify(data) },

        };
        axios(option)
          .then((e) => {
            setLoading(false);
            if (e?.status === 200) {
              toast.success(e?.data?.message);
            }
          })
          .catch((error) => {
            setLoading(false);
          });
      };
  return (
    <>
    {loading ? <Loader /> : null}
    <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
    <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
            <div
                className={
                    showSidebar
                        ? "main-container-of-all-employees-TasksInProgress"
                        : "main-container-of-all-employees-page-new-Attendance-management"
                }
            >
                <div className="inner-container-of-all-employees-page-Holiday ">
                    <div className="header-of-employees-page-Holiday row">
                        <div className="all-employee-TasksInProgress col">
                            <h4>Task</h4>
                        </div>
                        <div className="all-employees-TasksInProgress col">
                            <div className="home-icon-Attendance-Holiday">
                                <BiHomeAlt className="home-icon-header-TasksInProgress" />
                            </div>
                            <div className="arrow-icon-TasksInProgress">
                                <MdKeyboardArrowRight />
                            </div>
                            <div className="employee-text-Attendance-Holiday">
                                <p>Task </p>
                            </div>
                            <div className="arrow-icon-TasksInProgress">
                                <MdKeyboardArrowRight />
                            </div>
                            <div className="all-employee-text-Attendance-Holiday">
                                <p>Tasks In Progress </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="body-part-outer-TasksInProgress-screen">
                    <div className="inner-body-container-of-employee-TasksInProgress row-12">
                        <div className="first-side-in-body-TasksInProgress col-6">
                            <div className="employee-text-in-Attendance-Holiday">
                                <h2>Task</h2>
                            </div>
                            <div className="input-for-search-in-employee-Attendance-Holiday">
                                <MdSearch className="search-icon-in-Attendance-Holiday" />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    // onChange={(e) => handleDataSearch(e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className= {TasksInProgressAllData.length?"table-in-all-emplyee-TasksInProgress" :"Nodataavailable" }>
                    {TasksInProgressAllData && TasksInProgressAllData.length > 0 ? (

                        <table className="table-main-TasksInProgress">
                            <thead className="thead-main-TasksInProgress">
                                <tr className="row-12">
                                    <th className="image-class-Holiday col-2 "> <p>
                                        Sr. no
                                        </p>
                                    </th>
                                    <th className="image-class-Holiday col-2 ">
                                    Assigned  To
                                    </th>
                                    <th className="image-class-Holiday col-2 ">Title</th>
                                    <th className="image-class-Holiday col-2 ">Description</th>
                                    
                                    <th className="image-class-Holiday col-2 ">Status</th>
                                    <th className="setUi-of-action">Action</th>
                                    
                                </tr>
                            </thead>

                            <tbody className="tbody-main-Attendance-Holiday">
                                
                            {TasksInProgressAllData?.sort((a, b) => {
    if (a.Status === "Completed" && b.Status !== "Completed") {
        return -1; // a comes before b
    } else if (a.Status !== "Completed" && b.Status === "Completed") {
        return 1; // b comes before a
    } else {
        return a.User?.UserName?.localeCompare(b.User?.UserName); 
    }
})?.map((item, index) => {
    return (
        <tr key={index}>
            <>
                <td>{index + 1}</td>
                <td>{item?.User?.UserName}</td>
                <td>{item.Task.Title}</td>
                <td>{item.Task?.Description}</td>
                <td>{item.Status}</td>
                {item.Status === "Completed" ? (
                    <td>
                        <button className='TaskReviwedasSuccess-button' onClick={() => TaskSuccess(item)}>Task Success</button>
                        <button className='taskFailed-buttton' onClick={() => TaskFailed(item)}>Task Failed</button>
                    </td>
                ) : (
                    "-"
                )}
            </>
        </tr>
    );
})}


                            </tbody>

                        </table>
                        ) : (
                            <div>
                                <p>No data available</p>
                            </div>
                          )}
                    </div>
                </div>
            </div>
        </>
    </div>


   
    
</>
  )
}

export default TasksInProgress